import { defaultSwiperOptions } from '../../General/SwiperInit';
import Swiper, {
    Navigation,
    Pagination,
    Mousewheel,
    A11y,
    EffectFade,
    Keyboard,
    Autoplay,
    Lazy,
    Scrollbar,
    EffectCoverflow,
} from 'swiper';

Swiper.use([
    Navigation,
    Pagination,
    Mousewheel,
    A11y,
    EffectFade,
    Keyboard,
    Autoplay,
    Lazy,
    Scrollbar,
    EffectCoverflow,
]);

function initTeaserCarousel() {
    const inBackend = document.body.classList.contains('neos-backend');
    const isFirefox = navigator.userAgent.search('Firefox') > -1;
    [...document.querySelectorAll('.teaser-carousel-container')].forEach((container) => {
        const sliderEl = container.querySelector('.teaser-carousel');
        if (!sliderEl) {
            return;
        }

        const swiper = new Swiper(sliderEl, {
            ...defaultSwiperOptions,
            // since the 3D effect interferes with
            // neos editable components (supposedly mouse events)
            // we remove the effect for Firefox in the backend
            effect: inBackend && isFirefox ? null : 'coverflow',
            slidesPerView: 1.5,
            centeredSlides: true,
            initialSlide: 1,
            spaceBetween: 40,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 200,
                // effect modifier (float between 0 and 1)
                modifier: 1,
                slideShadows: true,
            },

            breakpoints: {
                1025: {
                    slidesPerView: 3,
                    spaceBetween: 75,
                    coverflowEffect: {
                        slideShadows: false,
                    },
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 65,
                },
            },
            slideClass: 'teaser-carousel-item',
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    });
}

initTeaserCarousel();

document.addEventListener(
    'Neos.NodeCreated',
    function (event) {
        if (
            (event.detail.element && event.detail.element.classList.contains('teaser-slider-container')) ||
            event.detail.element.classList.contains('teaser-carousel-item')
        ) {
            initTeaserCarousel();
        }
    },
    false
);
